module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-300-vietnamese1.0925fd7.woff2";